module.exports = "/images/icon_social_fb_yellow.png?6c8b51b62c5cbcde582c55d8721fb8e0";